import React, { useEffect, useState } from 'react'
import { Badge, Button, Modal, Spinner } from 'react-bootstrap'
import announcementService from '../../services/announcement/AnnouncementService'

const typeLabel = type => {
    if (type === 'FEATURE') return 'Fitur Baru'
    if (type === 'IMPORTANT') return 'Penting'
    return 'Pembaruan'
}

const AnnouncementPopup = () => {
    const [announcement, setAnnouncement] = useState(null)
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [show, setShow] = useState(false)

    const load = async () => {
        if (!localStorage.getItem('token')) return
        setLoading(true)
        try {
            const response = await announcementService.active(true)
            const items = Array.isArray(response.data)
                ? response.data
                : (response.data?.content || [])
            if (items.length > 0) {
                setAnnouncement(items[0])
                setShow(true)
            }
        } catch (_) {
            // Pengumuman tidak boleh menghalangi aplikasi utama.
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const timer = setTimeout(load, 350)
        return () => clearTimeout(timer)
    }, [])

    const closeAndMarkRead = async () => {
        if (!announcement) return
        setSaving(true)
        try {
            await announcementService.markRead(announcement.id)
        } catch (_) {
            // Jangan menahan user di popup jika endpoint gagal.
        } finally {
            setSaving(false)
            setShow(false)
        }
    }

    if (loading && !announcement) return null

    return (
        <Modal show={show} onHide={closeAndMarkRead} centered size="lg" backdrop="static" scrollable>
            {announcement?.imageUrl && (
                <div style={{ maxHeight: 260, overflow: 'hidden' }}>
                    <img src={announcement.imageUrl} alt="" className="w-100" style={{ objectFit: 'cover', maxHeight: 260 }} />
                </div>
            )}
            <Modal.Header closeButton={!saving}>
                <div>
                    <Badge bg={announcement?.type === 'IMPORTANT' ? 'danger' : 'primary'} className="mb-2">
                        {typeLabel(announcement?.type)}
                    </Badge>
                    <Modal.Title><h3>{announcement?.title}</h3></Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                {announcement?.summary && <p className="fw-semibold mb-3">{announcement.summary}</p>}
                <div style={{ whiteSpace: 'pre-line' }}>{announcement?.content}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={closeAndMarkRead} disabled={saving}>
                    {saving ? <><Spinner size="sm" className="me-2" />Menyimpan...</> : 'Saya Mengerti'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AnnouncementPopup
